package com.tovtalk.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.tovtalk.domain.repository.AdsRepository
import com.tovtalk.utils.logger.Logger

@Composable
fun NativeAdCard(
    slotIndex: Int,
    adsRepository: AdsRepository,
    modifier: Modifier = Modifier,
) {
    var adUrl by remember(slotIndex) { mutableStateOf<String?>(null) }

    LaunchedEffect(slotIndex) {
        val url = runCatching { adsRepository.buildInterstitialUrl() }
        Logger.d("NativeAdCard slot=$slotIndex url=${url.getOrNull()} err=${url.exceptionOrNull()?.message}", "ADS")
        adUrl = url.getOrNull()
    }

    val url = adUrl
    Logger.d("NativeAdCard render slot=$slotIndex url=$url", "ADS")
    if (url != null) {
        BannerAdView(
            url = url,
            modifier = modifier.fillMaxSize()
        )
    } else {
        Box(
            modifier = modifier
                .fillMaxSize()
                .background(Color.Black)
        )
    }
}
